import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../assets/logo2.png';

export default function Header() {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [resetPhone, setResetPhone] = useState('');
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [loadingReset, setLoadingReset] = useState(false);
  const [message, setMessage] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [country, setCountry] = useState('');

  useEffect(() => {
    fetch('https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry')
      .then(resp => resp.text())
      .then(code => {
        setCountry(code.toLowerCase());
        console.log('Country:', code.toLowerCase());
      })
      .catch(err => console.error(err));
  }, []); // ✅ added [] so it only runs once

  function Login(e) {
    e.preventDefault();
    setLoadingLogin(true);

    fetch(
      `https://apiv2.mobileartsme.com/login?phonenumber=${phone}&password=${password}&serviceid=4886&type=signin&country=${country}`
    )
      .then(resp => resp.json())
      .then(response => {
        if (response.Error === 0) {
          if (response.Result.Status === 0) {
            response.Result.Phone = phone;
            localStorage.setItem('GPP_User_Data', JSON.stringify(response.Result));
            window.location.href = '/dashboard/home';
          } else {
            setMessage(response.Result.Description);
          }
        } else {
          setMessage(response.Result.Description);
        }
      })
      .catch(() => setMessage('Login failed.'))
      .finally(() => setLoadingLogin(false));
  }

  function LoginNoPass(e) {
    e.preventDefault();
    setLoadingLogin(true);

    fetch(
      `https://apiv2.mobileartsme.com/LoginWithoutPass?IDService=4886&MSISDN=${phone}&IDProvider=411`
    )
      .then(resp => resp.json())
      .then(response => {
        if (response.Error === 0) {
          if (response.Result.Status === 0) {
            response.Result.Phone = phone;
            localStorage.setItem('GPP_User_Data', JSON.stringify(response.Result));
            window.location.href = '/dashboard/home';
          } else {
            setMessage(response.Result.Description);
          }
        } else {
          setMessage(response.Result);
        }
      })
      .catch(() => setMessage('Login failed.'))
      .finally(() => setLoadingLogin(false));
  }

  function ResetPassword(e) {
    e.preventDefault();
    setLoadingReset(true);
    fetch(
      `https://apiv2.mobileartsme.com/gbox_ForgetPassword?phonenumber=${resetPhone}&apisource=1&language=LB`
    )
      .then(resp => resp.json())
      .then(response => {
        setResetMessage(response.result);
      })
      .finally(() => setLoadingReset(false));
  }

  return (
    <>
      <div className='header'>
        <div className="container ">
          <div className="d-flex flex-row justify-content-between align-items-center py-3">
            <img src={Logo} width={60} alt="Logo" />
            <div className="d-flex flex-row gap-4 align-items-center">
              <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#loginModal">
                Login
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Login Modal */}
      <div className="modal fade" id="loginModal" tabIndex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content p-3">
            <div className="modal-header" style={{ border: 'none' }}>
              <img src={Logo} width={70} alt="logo" />
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <h3>Login</h3>
              <p>Dive Into Over 500 Games With Gaming Pro Premium!</p>
              
              {/* 👇 Switch between Login and LoginNoPass */}
              <form onSubmit={country === 'za' ? LoginNoPass : Login}>
                <div className="mb-3">
                  <label className="form-label" style={{ fontWeight: '500' }}>Phone Number</label>
                  <input
                    type="text"
                    value={phone}
                    placeholder='Phone Number'
                    onChange={e => setPhone(e.target.value)}
                    className="form-control text-dark"
                    required
                  />
                </div>

                {/* 👇 Hide password input if country = za */}
                {country !== 'za' && (
                  <div className="mb-3">
                    <label className="form-label" style={{ fontWeight: '500' }}>Password</label>
                    <input
                      type="password"
                      value={password}
                      placeholder='Password'
                      onChange={e => setPassword(e.target.value)}
                      className="form-control text-dark"
                      required
                    />
                  </div>
                )}

                {message && <div className="alert alert-danger">{message}</div>}

                <button type="submit" className="btn btn-primary w-100 br-full" >
                  {loadingLogin ? (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  ) : 'Login'}
                </button>

                {/* 👇 Hide forgot password if country = za */}
                {country !== 'za' && (
                  <div className="text-center mt-3">
                    <button
                      type="button"
                      className="btn p-0"
                      data-bs-toggle="modal"
                      data-bs-target="#resetModal"
                      data-bs-dismiss="modal"
                    >
                      Forgot Password?
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Reset Password Modal */}
      <div className="modal fade" id="resetModal" tabIndex="-1" aria-labelledby="resetModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content p-3">
            <div className="modal-header" style={{ border: 'none' }}>
              <h5 className="modal-title" id="resetModalLabel">Reset Password</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <p>Enter your phone number and we will send you a message with your new password.</p>
              <form onSubmit={ResetPassword}>
                <div className="mb-3">
                  <input
                    type="tel"
                    placeholder="Phone number"
                    value={resetPhone}
                    onChange={e => setResetPhone(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary w-100" disabled={loadingReset}>
                  {loadingReset ? (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  ) : 'Reset Password'}
                </button>

                {resetMessage && <div className="alert alert-danger mt-3">{resetMessage}</div>}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
